import styled from 'styled-components';

export const StyledSummaryElement = styled.div``;
